import axios from 'axios'
import { Message, MessageBox } from "element-ui";
import Cookies from "js-cookie";
import { getToken, removeToken } from "@/utils/auth";
import router from "@/router";
import Loading from '@/components/Loading.vue'
import Vue from 'vue'
import store from "@/store";
import i18n from "@/lang";

// 基础配置
// const baseUrl = '123.56.118.103:8090/api';
const baseUrl = 'innaspindle.com/api';
// const baseUrl = 'localhost:8080'
const tokenRequiredPrefixes = [
    '/h5',
]
// 创建Loading实例并挂载到页面
const loadingInstance = new Vue(Loading).$mount()
document.body.appendChild(loadingInstance.$el)
window.loadingInstance = loadingInstance

// 新增：请求计数器（管理并发请求）
let requestCount = 0

// 关键修改：创建单例axios实例（避免重复创建）
const service = axios.create({
    headers: {},
    timeout: 600000 // 请求超时时间
})

// 请求拦截器（仅添加一次）
service.interceptors.request.use(
    config => {
        loadingInstance.visible = true;
        loadingInstance.isLeaving = false;
        loadingInstance.$el.classList.remove('leaving', 'animate-fade');

        // 等待DOM更新后再触发淡入动画（确保从opacity:0开始）
        loadingInstance.$nextTick(() => {
            loadingInstance.$el.classList.add('animate-fade');
        });
        console.log('请求开始',store.getters.getCurrentLanguage)
        config.headers['Accept-Language'] = store.getters.getCurrentLanguage;
        // Token验证逻辑
        const needToken = tokenRequiredPrefixes.some(prefix => {
            return config.url.startsWith('https://' + baseUrl + prefix)
        })

        if (needToken) {
            const token = Cookies.get('token')
            if (token) {
                config.headers['Authorization'] = token
            } else {
                if (window.isRefreshing) return Promise.reject(new Error('未登录，无法访问该接口'))
                window.isRefreshing = true

                MessageBox.confirm(
                    i18n.t('login.expiredMessage'),
                    i18n.t('login.expiredTitle'),
                    {
                        confirmButtonText: i18n.t('userInfo.messages.confirm'),
                        cancelButtonText: i18n.t('userInfo.messages.cancel'),
                        type: 'warning',
                    }
                ).then(() => {
                    removeToken()
                    router.replace({
                        path: '/login',
                        query: { redirect: router.currentRoute.fullPath }
                    })
                }).catch(() => {
                    removeToken()
                }).finally(() => {
                    window.isRefreshing = false
                    // 错误场景下减少计数器
                    requestCount--
                })

                return Promise.reject(new Error('未登录，无法访问该接口'))
            }
        }

        return config
    },
    error => {
        loadingInstance.isLeaving = true;
        setTimeout(() => {
            loadingInstance.visible = false; // 动画结束后隐藏
            loadingInstance.$el.classList.remove('leaving', 'animate-fade');
        }, 3000); // 与动画时长1s保持一致
        return Promise.reject(error);
    }
)

// 响应拦截器（仅添加一次）
service.interceptors.response.use(
    response => {
        loadingInstance.isLeaving = true;
        setTimeout(() => {
            loadingInstance.visible = false;
            loadingInstance.$el.classList.remove('leaving', 'animate-fade');
        }, 3000);

        const res = response.data;
        if (res.status && res.status !== 200) {
            if (res.status === 400 || res.status === 500) {
                Message({
                    message: res.message,
                    type: 'error',
                    duration: 3 * 5000
                })
            }
            return res
        } else {
            return res
        }
    },
    error => {
        loadingInstance.isLeaving = true;
        setTimeout(() => {
            loadingInstance.visible = false;
            loadingInstance.$el.classList.remove('leaving', 'animate-fade');
        }, 3000);

        // Token过期处理
        if (window.isRefreshing) return Promise.reject(error)
        window.isRefreshing = true

        if (error.response && error.response.status === 401) {
            MessageBox.confirm(
                i18n.t('login.expiredMessage'),
                i18n.t('login.expiredTitle'),
                {
                    confirmButtonText: i18n.t('userInfo.messages.confirm'),
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                removeToken()
                router.replace({
                    path: '/login',
                    query: { redirect: router.currentRoute.fullPath }
                })
            }).catch(() => {
                removeToken()
            }).finally(() => {
                window.isRefreshing = false
            })
        }

        return Promise.reject(error)
    }
)

// 请求函数（仅处理URL拼接，复用单例实例）
const request = (data, code) => {
    data.url = 'https://' + baseUrl + data.url
    return service(data)
}

export default request